import React, { useRef, useState } from 'react';

export default function FotoCaptura({ maxFotos = 3, onChange, iniciales }) {
  const [fotos, setFotos] = useState(
    Array.isArray(iniciales)
      ? iniciales.map((f, i) => ({ id: `ini_${i}`, dataURL: f.dataURL || f, nombre: f.nombre || `foto_${i + 1}.jpg` }))
      : []
  );
  const inputRef        = useRef(null); // cámara
  const inputGaleriaRef = useRef(null); // galería

  const handleCaptura = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const nuevas = [];
    let pendientes = files.length;

    files.forEach(file => {
      // Redimensionar a máximo 1200px para no sobrecargar el servidor
      const reader = new FileReader();
      reader.onload = (ev) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const MAX = 1200;
          let w = img.width, h = img.height;
          if (w > MAX || h > MAX) {
            if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
            else { w = Math.round(w * MAX / h); h = MAX; }
          }
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          nuevas.push({
            id: Date.now() + Math.random(),
            dataURL: canvas.toDataURL('image/jpeg', 0.82),
            nombre: file.name,
          });
          pendientes--;
          if (pendientes === 0) {
            setFotos(prev => {
              const todas = [...prev, ...nuevas].slice(0, maxFotos);
              onChange(todas);
              return todas;
            });
          }
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
    });

    // Reset input para permitir seleccionar la misma foto de nuevo
    e.target.value = '';
  };

  const eliminar = (id) => {
    setFotos(prev => {
      const nuevas = prev.filter(f => f.id !== id);
      onChange(nuevas);
      return nuevas;
    });
  };

  const restantes = maxFotos - fotos.length;

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', marginBottom: 10 }}>
        <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>
          Fotos ({fotos.length}/{maxFotos})
        </label>
        {fotos.length > 0 && (
          <span style={{ fontSize: 12, color: '#777' }}>
            {restantes > 0 ? `Puedes agregar ${restantes} más` : 'Máximo alcanzado'}
          </span>
        )}
      </div>

      {/* Grid de fotos tomadas */}
      {fotos.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
                      gap: 8, marginBottom: 12 }}>
          {fotos.map(foto => (
            <div key={foto.id} style={{ position: 'relative', borderRadius: 10,
                                        overflow: 'hidden', aspectRatio: '1' }}>
              <img
                src={foto.dataURL}
                alt="evidencia"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <button
                onClick={() => eliminar(foto.id)}
                style={{
                  position: 'absolute', top: 4, right: 4,
                  background: 'rgba(0,0,0,0.6)', color: 'white',
                  border: 'none', borderRadius: '50%',
                  width: 24, height: 24, fontSize: 14,
                  cursor: 'pointer', lineHeight: 1,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Botones de captura */}
      {restantes > 0 && (
        <>
          {/* Input cámara */}
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            capture="environment"
            multiple={restantes > 1}
            onChange={handleCaptura}
            style={{ display: 'none' }}
          />
          {/* Input galería (sin capture para acceder a archivos existentes) */}
          <input
            ref={inputGaleriaRef}
            type="file"
            accept="image/*"
            multiple={restantes > 1}
            onChange={handleCaptura}
            style={{ display: 'none' }}
          />
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              type="button"
              onClick={() => inputRef.current.click()}
              style={{
                flex: 1, padding: '12px',
                border: '2px dashed #0f6e56', borderRadius: 12,
                background: '#e8f5f1', color: '#0f6e56',
                fontSize: 13, fontWeight: 600, cursor: 'pointer',
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', gap: 6,
              }}>
              📷 Cámara
            </button>
            <button
              type="button"
              onClick={() => inputGaleriaRef.current.click()}
              style={{
                flex: 1, padding: '12px',
                border: '2px dashed #555', borderRadius: 12,
                background: '#f5f5f5', color: '#555',
                fontSize: 13, fontWeight: 600, cursor: 'pointer',
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', gap: 6,
              }}>
              🖼 Galería
            </button>
          </div>
        </>
      )}
    </div>
  );
}
